import { HomepageController } from './controllers/HomepageController';
import { MegaMenuController } from './controllers/MegaMenuController';
import { MobileMenuController } from './controllers/MobileMenuController';
import { MobileLanguageController } from './controllers/MobileLanguageController';
import { ProductFilterController } from './controllers/ProductFilterController';
import { AccordionController } from './controllers/AccordionController';
import { VerticalSelectController } from './controllers/VerticalSelectController';
import { PostGridSliderController } from './controllers/PostGridSliderController';
import { ProductGalleryController } from './controllers/ProductGalleryController';
import { DragScrollController } from './controllers/DragScrollController';
import { AnchorLinkController } from './controllers/AnchorLinkController';
import { PopupArticleController } from './controllers/PopupArticleController';
import { WebGLController } from './controllers/WebGLController';
import { RightClickController } from './controllers/RightClickController';


window.addEventListener('load', () => {
  HomepageController();
  if($('body').hasClass('home')) {
    WebGLController();
  }
  PopupArticleController();

  MegaMenuController();
  MobileMenuController();
  MobileLanguageController();
  ProductFilterController();
  AccordionController();
  VerticalSelectController();
  PostGridSliderController();
  ProductGalleryController();
  DragScrollController();
  AnchorLinkController();
  RightClickController();
});



// WEBPACK FOOTER //
// ./src/js/app.js